const works = () => {
  const target = document.getElementById('js-change-point');
  if(target != null) {
    const endTarget = document.querySelector('.js-change-img-end'); // エンドセクションのターゲットを選択
    const targetImgDiv = document.querySelector('.js-change-img');
    let lastY = 0; // 最後に監視されたスクロール位置 (Y座標)

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        const currentY = entry.boundingClientRect.y; // 現在のY座標
        const scrollingDown = currentY < lastY; // 前回のY座標より小さければ下にスクロールしたと判断
        lastY = currentY; // Y座標の更新
        if (entry.isIntersecting) {
          targetImgDiv.classList.add('is-next');
        } else if (!scrollingDown) { // 上にスクロールした場合のみ is-next を削除
          targetImgDiv.classList.remove('is-next');
        }
      });
    };

    let observer = new IntersectionObserver(callback, options);
    observer.observe(target);

    // .js-change-img-end に対して新しいIntersection Observerを追加
    const endCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          targetImgDiv.classList.add('is-end'); // is-end クラスを追加
        } else {
          targetImgDiv.classList.remove('is-end'); // is-end クラスを除去
        }
      });
    };

    let endObserver = new IntersectionObserver(endCallback, options);
    endObserver.observe(endTarget);
  }
};
